/**
 * Tema-duyarlı (context-aware) notification köprüsü.
 *
 * antd v5'te doğrudan `import { notification } from 'antd'` ile yapılan STATİK
 * çağrılar, ConfigProvider'ın dinamik temasını (colorPrimary vb.) tüketemez ve
 * "Static function can not consume context" uyarısı verir.
 *
 * Çözüm: kök <App> içinde App.useApp() ile alınan notification örneği
 * registerNotify() ile buraya kaydedilir; bileşenler bu `notify`yi statik
 * notification yerine kullanır (aynı API: warning/error/success/info/open).
 */
let api = null;

export const registerNotify = (instance) => {
    api = instance;
};

const call = (type) => (config) => (api ? api[type](config) : undefined);

const notify = {
    open: call('open'),
    success: call('success'),
    error: call('error'),
    warning: call('warning'),
    info: call('info'),
    destroy: (key) => (api && api.destroy ? api.destroy(key) : undefined),
};

export { notify };
export default notify;
